import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { hasExplicitPermissionRule, useAbility } from '@features/authorization';
import { useAuth } from '@features/auth';
import { AdminHelpdeskSettingsPage } from '@pages/admin';
import { canAccessHelpdesk } from '@shared/lib';
import type { RouterContext } from '@shared/config/router-context';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings/helpdesk')({
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;
    if (auth.isLoading || !auth.isAuthenticated) return;
    if (
      !canAccessHelpdesk(ability) ||
      !hasExplicitPermissionRule(auth.permissions, 'read', 'AdminTools')
    ) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
    }
  },
  component: AdminHelpdeskSettingsRoute,
});

function AdminHelpdeskSettingsRoute() {
  const { locale } = Route.useParams();
  const auth = useAuth();
  const ability = useAbility();
  if (auth.isLoading || !auth.isAuthenticated) return null;
  if (
    !canAccessHelpdesk(ability) ||
    !hasExplicitPermissionRule(auth.permissions, 'read', 'AdminTools')
  ) {
    return <Navigate to="/$locale/unauthorized" params={{ locale }} replace />;
  }
  return <AdminHelpdeskSettingsPage />;
}
